import { render, staticRenderFns } from "./add-note.vue?vue&type=template&id=69300014&scoped=true"
import script from "./add-note.vue?vue&type=script&lang=ts"
export * from "./add-note.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69300014",
  null
  
)

export default component.exports